export const DDL_MODAL_ID = 'DdlModal'
